export default function ParaQuem() {
  const perfis = [
    {
      icon: 'ri-briefcase-line',
      titulo: 'Empreendedores',
      descricao: 'Que querem estruturar e escalar seus negócios no digital com estratégia clara'
    },
    {
      icon: 'ri-user-star-line',
      titulo: 'Profissionais Liberais',
      descricao: 'Qualquer pessoa que se interesse em começar ou crescer o seu negócio.'
    }
  ];

  const naoEPara = [
    'Quem busca fórmulas mágicas ou enriquecimento rápido',
    'Quem não está disposto a colocar em prática o que aprender',
    'Quem quer apenas consumir conteúdo sem aplicar',
    'Quem não tem interesse em construir um negócio sério'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Para quem é este curso
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Este curso é perfeito para você!
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {perfis.map((perfil, index) => (
            <div
              key={index}
              className="flex items-start gap-6 p-8 bg-purple-50 rounded-2xl hover:bg-purple-100 transition-all"
            >
              <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className={`${perfil.icon} text-purple-900 text-3xl`}></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{perfil.titulo}</h3>
                <p className="text-gray-700 leading-relaxed">{perfil.descricao}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-gray-900 rounded-3xl p-10 lg:p-14">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-8">
              Este curso NÃO é para você se...
            </h3>
            <div className="space-y-4">
              {naoEPara.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 bg-white/5 backdrop-blur-sm border border-gray-700 rounded-xl p-5 text-left"
                >
                  <i className="ri-close-circle-line text-red-400 text-2xl flex-shrink-0"></i>
                  <p className="text-gray-300">{item}</p>
                </div>
              ))}
            </div>
            <p className="text-yellow-400 text-lg font-semibold mt-8">
              Aqui a gente fala sério sobre construir um negócio de verdade, com base sólida e resultados reais.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
